/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  StyledH1,
  StyledParagraph,
  StyledStrong,
  StyledUl,
  StyledUlParagraph,
} from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const PrivacyScreen: React.FC<any> = () => {
  // =============== VIEWS
  return (
    <div>
      <div className="">
        <StyledH1>Privacy Policy</StyledH1>
        <StyledParagraph>
          <StyledStrong>Privacy Policy of&nbsp;www.caricarz.com</StyledStrong>
          <br />
          This Application collects some Personal Data from its Users.
        </StyledParagraph>
        <StyledParagraph>
          This document can be printed for reference by using the print command
          in the settings of any browser.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Owner and Data Controller</StyledStrong>
          <br />
          Caricarz Sdn Bhd
          <br />
          <StyledStrong>Owner contact email:</StyledStrong>
          &nbsp;support@caricarz.com
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Types of Data collected</StyledStrong>
          <br />
          Among the types of Personal Data that this Application collects, by
          itself or through third parties, there are: email address; Usage Data.
          <br />
          Complete details on each type of Personal Data collected are provided
          in the dedicated sections of this privacy policy or by specific
          explanation texts displayed prior to the Data collection.
          <br />
          Personal Data may be freely provided by the User, or, in case of Usage
          Data, collected automatically when using this Application.
          <br />
          Unless specified otherwise, all Data requested by this Application is
          mandatory and failure to provide this Data may make it impossible for
          this Application to provide its services. In cases where this
          Application specifically states that some Data is not mandatory, Users
          are free not to communicate this Data without consequences to the
          availability or the functioning of the Service.
          <br />
          Users who are uncertain about which Personal Data is mandatory are
          welcome to contact the Owner.
          <br />
          Any use of Cookies – or of other tracking tools – by this Application
          or by the owners of third-party services used by this Application
          serves the purpose of providing the Service required by the User, in
          addition to any other purposes described in the present document and
          in the Cookie Policy, if available.
          <br />
          Users are responsible for any third-party Personal Data obtained,
          published or shared through this Application and confirm that they
          have the third party's consent to provide the Data to the Owner.
        </StyledParagraph>
        <StyledUlParagraph>
          <StyledStrong>Mode and place of processing the Data</StyledStrong>
          <br />
          <StyledStrong>Methods of processing</StyledStrong>
          <br />
          The Owner takes appropriate security measures to prevent unauthorized
          access, disclosure, modification, or unauthorized destruction of the
          Data.
          <br />
          The Data processing is carried out using computers and/or IT enabled
          tools, following organizational procedures and modes strictly related
          to the purposes indicated. In addition to the Owner, in some cases,
          the Data may be accessible to certain types of persons in charge,
          involved with the operation of this Application (administration,
          sales, marketing, legal, system administration) or external parties
          (such as third-party technical service providers, mail carriers,
          hosting providers, IT companies, communications agencies) appointed,
          if necessary, as Data Processors by the Owner. The updated list of
          these parties may be requested from the Owner at any time.
          <br />
          <br />
          <StyledStrong>Legal basis of processing</StyledStrong>
          <br />
          The Owner may process Personal Data relating to Users if one of the
          following applies:
        </StyledUlParagraph>
        <StyledUl>
          <li>
            Users have given their consent for one or more specific purposes.
            Note: Under some legislations the Owner may be allowed to process
            Personal Data until the User objects to such processing
            (&ldquo;opt-out&rdquo;), without having to rely on consent or any
            other of the following legal bases. This, however, does not apply,
            whenever the processing of Personal Data is subject to European data
            protection law;
          </li>
          <li>
            provision of Data is necessary for the performance of an agreement
            with the User and/or for any pre-contractual obligations thereof;
          </li>
          <li>
            processing is necessary for compliance with a legal obligation to
            which the Owner is subject;
          </li>
          <li>
            processing is related to a task that is carried out in the public
            interest or in the exercise of official authority vested in the
            Owner;
          </li>
          <li>
            processing is necessary for the purposes of the legitimate interests
            pursued by the Owner or by a third party.
          </li>
        </StyledUl>

        <StyledUlParagraph>
          In any case, the Owner will gladly help to clarify the specific legal
          basis that applies to the processing, and in particular whether the
          provision of Personal Data is a statutory or contractual requirement,
          or a requirement necessary to enter into a contract.&nbsp;
          <br />
          <br />
          <StyledStrong>Place</StyledStrong>
          <br />
          The Data is processed at the Owner's operating offices and in any
          other places where the parties involved in the processing are located.
          <br />
          Depending on the User's location, data transfers may involve
          transferring the User's Data to a country other than their own. To
          find out more about the place of processing of such transferred Data,
          Users can check the section containing details about the processing of
          Personal Data.
          <br />
          Users are also entitled to learn about the legal basis of Data
          transfers to a country outside the European Union or to any
          international organization governed by public international law or set
          up by two or more countries, such as the UN, and about the security
          measures taken by the Owner to safeguard their Data.
          <br />
          If any such transfer takes place, Users can find out more by checking
          the relevant sections of this document or inquire with the Owner using
          the information provided in the contact section.
          <br />
          <br />
          <StyledStrong>Retention time</StyledStrong>
          <br />
          Personal Data shall be processed and stored for as long as required by
          the purpose they have been collected for.
          <br />
          Therefore:
        </StyledUlParagraph>
        <StyledUl>
          <li>
            Personal Data collected for purposes related to the performance of a
            contract between the Owner and the User shall be retained until such
            contract has been fully performed.
          </li>
          <li>
            Personal Data collected for the purposes of the Owner&rsquo;s
            legitimate interests shall be retained as long as needed to fulfill
            such purposes. Users may find specific information regarding the
            legitimate interests pursued by the Owner within the relevant
            sections of this document or by contacting the Owner.
          </li>
        </StyledUl>
        <StyledParagraph>
          The Owner may be allowed to retain Personal Data for a longer period
          whenever the User has given consent to such processing, as long as
          such consent is not withdrawn. Furthermore, the Owner may be obliged
          to retain Personal Data for a longer period whenever required to do so
          for the performance of a legal obligation or upon order of an
          authority.
          <br />
          <br />
          Once the retention period expires, Personal Data shall be deleted.
          Therefore, the right to access, the right to erasure, the right to
          rectification and the right to data portability cannot be enforced
          after expiration of the retention period.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>The purposes of processing</StyledStrong>
          <br />
          The Data concerning the User is collected to allow the Owner to
          provide its Service, comply with its legal obligations, respond to
          enforcement requests, protect its rights and interests (or those of
          its Users or third parties), detect any malicious or fraudulent
          activity, as well as the following: Contacting the User, Access to
          third-party accounts and Displaying content from external platforms.
          <br />
          For specific information about the Personal Data used for each
          purpose, the User may refer to the section &ldquo;Detailed information
          on the processing of Personal Data&rdquo;.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>
            Facebook permissions asked by this Application
          </StyledStrong>
          <br />
          This Application may ask for some Facebook permissions allowing it to
          perform actions with the User's Facebook account and to retrieve
          information, including Personal Data, from it. This service allows
          this Application to connect with the User's account on the Facebook
          social network, provided by Facebook Inc.
          <br />
          For more information about the following permissions, refer to
          the&nbsp;
          <a
            href="https://developers.facebook.com/docs/facebook-login/permissions"
            target="_blank"
          >
            Facebook permissions documentation
          </a>
          &nbsp;and to the&nbsp;
          <a href="https://www.facebook.com/about/privacy/" target="_blank">
            Facebook privacy policy
          </a>
          .<br />
          The permissions asked are the following:
          <br />
          <StyledStrong>Basic information</StyledStrong>
          <br />
          By default, this includes certain User&rsquo;s Data such as id, name,
          picture, gender, and their locale. Certain connections of the User,
          such as the Friends, are also available. If the User has made more of
          their Data public, more information will be available.
          <br />
          <StyledStrong>Contact email</StyledStrong>
          <br />
          Access the User's contact email address.
          <br />
          <StyledStrong>Gender</StyledStrong>
          <br />
          Provides access to the User's gender.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>
            Detailed information on the processing of Personal Data
          </StyledStrong>
          <br />
          Personal Data is collected for the following purposes and using the
          following services:
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Access to third-party accounts</StyledStrong> <br />
          This type of service allows this Application to access Data from your
          account on a third-party service and perform actions with it.
          <br />
          These services are not activated automatically, but require explicit
          authorization by the User.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Facebook account access (Facebook, Inc.)</StyledStrong>
          <br />
          This service allows this Application to connect with the User's
          account on the Facebook social network, provided by Facebook, Inc.
          <br />
          Permissions asked: Contact email; Gender.
          <br />
          Place of processing: United States –&nbsp;
          <a href="https://www.facebook.com/policy.php" target="_blank">
            Privacy Policy
          </a>
          . Privacy Shield participant.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Contacting the User</StyledStrong> <br />
          <StyledStrong>
            Mailing list or newsletter (this Application)
          </StyledStrong>
          <br />
          By registering on the mailing list or for the newsletter, the
          User&rsquo;s email address will be added to the contact list of those
          who may receive email messages containing information of commercial or
          promotional nature concerning this Application. Your email address
          might also be added to this list as a result of signing up to this
          Application or after making a purchase.
          <br />
          Personal Data processed: email address.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>
            Displaying content from external platforms
          </StyledStrong>
          <br />
          This type of service allows you to view content hosted on external
          platforms directly from the pages of this Application and interact
          with them.
          <br />
          This type of service might still collect web traffic data for the
          pages where the service is installed, even when Users do not use it.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Google Fonts (Google LLC)</StyledStrong>
          <br />
          Google Fonts is a typeface visualization service provided by Google
          LLC that allows this Application to incorporate content of this kind
          on its pages.
          <br />
          Personal Data processed: Usage Data; various types of Data as
          specified in the privacy policy of the service.
          <br />
          Place of processing: United States –&nbsp;
          <a href="https://policies.google.com/privacy" target="_blank">
            Privacy Policy
          </a>
          . Privacy Shield participant.
        </StyledParagraph>
        <StyledUlParagraph>
          <StyledStrong>The rights of Users</StyledStrong>
          <br />
          Users may exercise certain rights regarding their Data processed by
          the Owner.
          <br />
          In particular, Users have the right to do the following:
        </StyledUlParagraph>
        <StyledUl>
          <li>
            <StyledStrong>Withdraw their consent at any time.</StyledStrong>
            &nbsp;Users have the right to withdraw consent where they have
            previously given their consent to the processing of their Personal
            Data.
          </li>
          <li>
            <StyledStrong>Object to processing of their Data.</StyledStrong>
            &nbsp;Users have the right to object to the processing of their Data
            if the processing is carried out on a legal basis other than
            consent. Further details are provided in the dedicated section
            below.
          </li>
          <li>
            <StyledStrong>Access their Data.</StyledStrong>&nbsp;Users have the
            right to learn if Data is being processed by the Owner, obtain
            disclosure regarding certain aspects of the processing and obtain a
            copy of the Data undergoing processing.
          </li>
          <li>
            <StyledStrong>Verify and seek rectification.</StyledStrong>
            &nbsp;Users have the right to verify the accuracy of their Data and
            ask for it to be updated or corrected.
          </li>
          <li>
            <StyledStrong>Restrict the processing of their Data.</StyledStrong>
            &nbsp;Users have the right, under certain circumstances, to restrict
            the processing of their Data. In this case, the Owner will not
            process their Data for any purpose other than storing it.
          </li>
          <li>
            <StyledStrong>
              Have their Personal Data deleted or otherwise removed.
            </StyledStrong>
            &nbsp;Users have the right, under certain circumstances, to obtain
            the erasure of their Data from the Owner by emailing us at{' '}
            <a href="mailto:support@caricarz.com">support@caircarz.com</a>
          </li>
          <li>
            <StyledStrong>
              Receive their Data and have it transferred to another controller.
            </StyledStrong>
            &nbsp;Users have the right to receive their Data in a structured,
            commonly used and machine readable format and, if technically
            feasible, to have it transmitted to another controller without any
            hindrance. This provision is applicable provided that the Data is
            processed by automated means and that the processing is based on the
            User's consent, on a contract which the User is part of or on
            pre-contractual obligations thereof.
          </li>
          <li>
            <StyledStrong>Lodge a complaint.</StyledStrong>&nbsp;Users have the
            right to bring a claim before their competent data protection
            authority.
          </li>
        </StyledUl>
        <StyledParagraph>
          <StyledStrong>
            Details about the right to object to processing
          </StyledStrong>
          <br />
          Where Personal Data is processed for a public interest, in the
          exercise of an official authority vested in the Owner or for the
          purposes of the legitimate interests pursued by the Owner, Users may
          object to such processing by providing a ground related to their
          particular situation to justify the objection.
          <br />
          Users must know that, however, should their Personal Data be processed
          for direct marketing purposes, they can object to that processing at
          any time without providing any justification. To learn, whether the
          Owner is processing Personal Data for direct marketing purposes, Users
          may refer to the relevant sections of this document.&nbsp;
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>How to exercise these rights</StyledStrong>
          <br />
          Any requests to exercise User rights can be directed to the Owner
          through the contact details provided in this document. These requests
          can be exercised free of charge and will be addressed by the Owner as
          early as possible and always within one month.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>
            Additional information about Data collection and processing
          </StyledStrong>
          <br />
          <StyledStrong>Legal action</StyledStrong>
          <br />
          The User's Personal Data may be used for legal purposes by the Owner
          in Court or in the stages leading to possible legal action arising
          from improper use of this Application or the related Services.
          <br />
          The User declares to be aware that the Owner may be required to reveal
          personal data upon request of public authorities.
          <br />
          <StyledStrong>
            Additional information about User's Personal Data
          </StyledStrong>
          <br />
          In addition to the information contained in this privacy policy, this
          Application may provide the User with additional and contextual
          information concerning particular Services or the collection and
          processing of Personal Data upon request.
          <br />
          <StyledStrong>System logs and maintenance</StyledStrong>
          <br />
          For operation and maintenance purposes, this Application and any
          third-party services may collect files that record interaction with
          this Application (System logs) use other Personal Data (such as the IP
          Address) for this purpose.
          <br />
          <StyledStrong>Information not contained in this policy</StyledStrong>
          <br />
          More details concerning the collection or processing of Personal Data
          may be requested from the Owner at any time. Please see the contact
          information at the beginning of this document.
          <br />
          <StyledStrong>
            How &ldquo;Do Not Track&rdquo; requests are handled
          </StyledStrong>
          <br />
          This Application does not support &ldquo;Do Not Track&rdquo; requests.
          <br />
          To determine whether any of the third-party services it uses honor the
          &ldquo;Do Not Track&rdquo; requests, please read their privacy
          policies.
          <br />
          <StyledStrong>Changes to this privacy policy</StyledStrong>
          <br />
          The Owner reserves the right to make changes to this privacy policy at
          any time by notifying its Users on this page and possibly within this
          Application and/or - as far as technically and legally feasible -
          sending a notice to Users via any contact information available to the
          Owner. It is StyledStrongly recommended to check this page often,
          referring to the date of the last modification listed at the
          bottom.&nbsp;
          <br />
          <br />
          Should the changes affect processing activities performed on the basis
          of the User&rsquo;s consent, the Owner shall collect new consent from
          the User, where required.
        </StyledParagraph>
        <div></div>
        <div>
          <StyledParagraph>
            <StyledStrong>
              Definitions and legal references
              <br />{' '}
            </StyledStrong>
            <StyledStrong>Personal Data (or Data)</StyledStrong>
            <StyledStrong>
              <br />{' '}
            </StyledStrong>
            Any information that directly, indirectly, or in connection with
            other information — including a personal identification number —
            allows for the identification or identifiability of a natural
            person.<StyledStrong> </StyledStrong>
          </StyledParagraph>
        </div>
        <StyledParagraph>
          <StyledStrong>Usage Data</StyledStrong>
          <br />
          Information collected automatically through this Application (or
          third-party services employed in this Application), which can include:
          the IP addresses or domain names of the computers utilized by the
          Users who use this Application, the URI addresses (Uniform Resource
          Identifier), the time of the request, the method utilized to submit
          the request to the server, the size of the file received in response,
          the numerical code indicating the status of the server's answer
          (successful outcome, error, etc.), the country of origin, the features
          of the browser and the operating system utilized by the User, the
          various time details per visit (e.g., the time spent on each page
          within the Application) and the details about the path followed within
          the Application with special reference to the sequence of pages
          visited, and other parameters about the device operating system and/or
          the User's IT environment.
          <br />
          <StyledStrong>User</StyledStrong>
          <br />
          The individual using this Application who, unless otherwise specified,
          coincides with the Data Subject.
          <br />
          <StyledStrong>Data Subject</StyledStrong>
          <br />
          The natural person to whom the Personal Data refers.
          <br />
          <StyledStrong>Data Processor (or Data Supervisor)</StyledStrong>
          <br />
          The natural or legal person, public authority, agency or other body
          which processes Personal Data on behalf of the Controller, as
          described in this privacy policy.
          <br />
          <StyledStrong>Data Controller (or Owner)</StyledStrong>
          <br />
          The natural or legal person, public authority, agency or other body
          which, alone or jointly with others, determines the purposes and means
          of the processing of Personal Data, including the security measures
          concerning the operation and use of this Application. The Data
          Controller, unless otherwise specified, is the Owner of this
          Application.
          <br />
          <StyledStrong>This Application</StyledStrong>
          <br />
          The means by which the Personal Data of the User is collected and
          processed.
          <br />
          <StyledStrong>Service</StyledStrong>
          <br />
          The service provided by this Application as described in the relative
          terms (if available) and on this site/application.
          <br />
          <StyledStrong>European Union (or EU)</StyledStrong>
          <br />
          Unless otherwise specified, all references made within this document
          to the European Union include all current member states to the
          European Union and the European Economic Area.
        </StyledParagraph>
        <StyledParagraph>
          <StyledStrong>Legal information</StyledStrong>
          <br />
          This privacy statement has been prepared based on provisions of
          multiple legislations, including Art. 13/14 of Regulation (EU)
          2016/679 (General Data Protection Regulation).
          <br />
          This privacy policy relates solely to this Application, if not stated
          otherwise within this document.
        </StyledParagraph>
      </div>
    </div>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default PrivacyScreen;
